<template>
  <tr v-if="table==='primary'">
    <td >{{day | dateToEs}}</td>
    <td class="text-center" v-for="(srv, index) in getServices" :key="srv.idService">
      <div class="checkbox">
        <label class="chkReservas">
          <input type="checkbox" :disabled="isDisabled(srv)"
                 @click="excludeServices(srv)"
                 v-model="result.filter((r) => r.id == srv.idService)[0].status" >
          <span class="cr"><i class="cr-icon fa fa-check"></i></span>
        </label>
      </div>
    </td>
    <td class="text-center" v-if="pernocta">
      <div class="checkbox">
        <label class="chkReservas">
          <input type="checkbox" disabled :checked="!last">
          <span class="cr"><i class="cr-icon fa fa-check"></i></span>
        </label>
      </div>
    </td>
  </tr>
  <tr v-else>
    <td >{{day | dateToEs}}</td>
    <td class="text-center" v-for="(srv, index) in getServices" :key="srv.idService">
      <div class="checkbox">
        <label class="chkReservas">
          <input type="checkbox"
                 @click="excludeServices(srv)"
                 :disabled="srv.obligatorio === '1' ? true : false"
                 v-model="result.filter((r) => r.id == srv.idService)[0].status" >
          <span class="cr"><i class="cr-icon fa fa-check"></i></span>
        </label>
      </div>
    </td>
    <td class="text-center" v-if="pernocta">
      <div class="checkbox">
        <label class="chkReservas">
          <input type="checkbox" disabled :checked="!last">
          <span class="cr"><i class="cr-icon fa fa-check"></i></span>
        </label>
      </div>
    </td>
  </tr>
</template>

<script>
  import {mapMutations} from 'vuex'

  export default {
    name: "ServiceRow",
    props:['bookingId', 'services', 'order', 'day', 'last', 'table', 'pernocta'],
    data(){
      return {
        result: [],
        finalServices:{},
        bloqueados: []
      }
    },
    created(){
      this.services.forEach((_srv) => {
        let status = true
        // Se comprueba que el servicio es de los principales. Desayuno, Comida, Picnic, Cena.
        if(_srv.principal !== 0) {
          // El desayuno del día de entrada y la cena del día de salida no se pueden seleccionar
          if((this.order === 0 && _srv.entrada === 0) || (this.last && _srv.salida === 0)){
            status = false
            // Para cualquier otro caso se comprueba que no sea obligatorio
          }else if(_srv.obligatorio === '0')
            status = false
          else {
            // En el caso de ser obligatorio obtenemos los servicios que no son compatibles
            this.bloqueados = this.bloqueados.concat(_srv.excluidos)
          }
        }else {
          if(_srv.obligatorio === '0') status = false
        }

        this.result.push(
          {
            id: _srv.idService,
            princial: _srv.principal,
            status : status,
            obligatorio: parseInt(_srv.obligatorio)
          })
        /*if(_srv.obligatorio === '1' && _srv.entrada!==0) {
          this.appendService({ reference: this.bookingId, day: this.day, service: _srv.idService } )
        }
        // Para la cena
        if(_srv.obligatorio === '1' && _srv.salida!==0) {
          this.appendService({ reference: this.bookingId, day: this.day, service: _srv.idService } )
        }*/
        if(status) this.appendService({ reference: this.bookingId, day: this.day, service: _srv.idService } )

      })
      this.finalServices[this.bookingId] = {[this.day]:[]}
    },
    filters:{
      dateToEs(_date){
        return _date.split('-').reverse().join('/')
      }
    },
    computed:{
      getServices(){
        return this.services
      }
    },
    methods:{
      ...mapMutations(['clearServicesDay', 'appendService','appendOtherService']),
      excludeServices(srv){
        //Limpia todos los servicios para evitar errores
        this.finalServices[this.bookingId][this.$vnode.key]=[]
        //Pone el estado que le corresponde al servicio seleccionado
        this.result.forEach(_s => { if(_s.id == srv.idService) _s.status = !_s.status })
        //Busca servicios que no pueden ir juntos y quita los incompatibles con el servicio seleccionado

        if(srv.excluidos)
          srv.excluidos.forEach((e) => {
            let _current = this.result.filter((r) => r.princial === e)[0]
            if(_current) _current.status = false
          })
        this.clearServicesDay({reference: this.bookingId, day:this.day})
        //Pone los servicios que son correctos
        this.result.forEach(r => {
          if (r.status){
            this.finalServices[this.bookingId][this.$vnode.key].push(r.id.toString())
            if(this.table === 'primary')
              this.appendService({ reference: this.bookingId, day: this.day, service: r.id } )
            else
              this.appendOtherService({ reference: this.bookingId, day: this.day, service: r.id } )
          }
        })
      },
      isDisabled(srv) {
        let disabled = false

        if ((this.last && srv.salida===0) || (this.order===0 && srv.entrada===0) || srv.obligatorio === '1' || this.bloqueados.includes(srv.principal))
          disabled = true
        return disabled
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/services/ServiceRow.vue